import { useEffect, useRef, useState } from "react";
import { Eraser } from "lucide-react";

export const SignaturePad = ({ onChange }) => {
  const canvasRef = useRef(null);
  const drawing = useRef(false);
  const [empty, setEmpty] = useState(true);

  useEffect(() => {
    const c = canvasRef.current;
    const ratio = window.devicePixelRatio || 1;
    c.width = c.offsetWidth * ratio;
    c.height = 180 * ratio;
    const ctx = c.getContext("2d");
    ctx.scale(ratio, ratio);
    ctx.lineWidth = 2.2;
    ctx.lineCap = "round";
    ctx.lineJoin = "round";
    ctx.strokeStyle = "#144733";
  }, []);

  const pos = (e) => {
    const r = canvasRef.current.getBoundingClientRect();
    return { x: e.clientX - r.left, y: e.clientY - r.top };
  };

  const start = (e) => {
    drawing.current = true;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.beginPath();
    ctx.moveTo(p.x, p.y);
    canvasRef.current.setPointerCapture(e.pointerId);
  };

  const move = (e) => {
    if (!drawing.current) return;
    const ctx = canvasRef.current.getContext("2d");
    const p = pos(e);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    if (empty) setEmpty(false);
  };

  const end = () => {
    if (!drawing.current) return;
    drawing.current = false;
    onChange(canvasRef.current.toDataURL("image/png"));
  };

  const clear = () => {
    const c = canvasRef.current;
    c.getContext("2d").clearRect(0, 0, c.width, c.height);
    setEmpty(true);
    onChange(null);
  };

  return (
    <div>
      <div className="relative border-2 border-dashed border-[#009900]/40 rounded-lg bg-white overflow-hidden">
        <canvas
          ref={canvasRef}
          className="w-full block cursor-crosshair"
          style={{ height: 180, touchAction: "none" }}
          onPointerDown={start}
          onPointerMove={move}
          onPointerUp={end}
          onPointerLeave={end}
          data-testid="signature-pad-canvas"
        />
        {empty && (
          <span className="absolute inset-0 flex items-center justify-center text-sm text-[#9aa79f] pointer-events-none">
            Sign here with your mouse or finger
          </span>
        )}
      </div>
      <button type="button" onClick={clear} className="mt-2 text-xs text-[#57685e] flex items-center gap-1.5 hover:text-[#144733]" data-testid="signature-clear-btn">
        <Eraser className="w-3.5 h-3.5" /> Clear signature
      </button>
    </div>
  );
};
